import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Bot } from "lucide-react";
import api from "../lib/api";

export default function LiveBotIndicator() {
  const [n, setN] = useState(0);
  const { pathname } = useLocation();
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/bots/live-running").then((r) => alive && setN(r.data.count)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    window.addEventListener("fx:bots-changed", load);
    return () => { alive = false; clearInterval(t); window.removeEventListener("fx:bots-changed", load); };
  }, [pathname]);
  if (!n) return null;
  return (
    <Link to="/bots" data-testid="live-bot-indicator" title="A bot is trading with real funds from your live wallet"
      className="flex items-center gap-2 h-9 rounded-full border border-neg/40 bg-neg/15 pl-2.5 pr-3 text-xs font-bold text-neg hover:bg-neg/25 transition-colors">
      <span className="relative flex h-2 w-2"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-neg opacity-75" /><span className="relative inline-flex h-2 w-2 rounded-full bg-neg" /></span>
      <Bot className="h-3.5 w-3.5" />
      <span className="hidden sm:inline">{n > 1 ? `${n} live bots running` : "Live bot running"}</span>
      <span className="sm:hidden">LIVE</span>
    </Link>
  );
}
